module.exports = __webpack_public_path__ + "img/na.b581f54c.png";